import navMenuItems from '@/layouts/components/vertical-nav-menu/navMenuItems';
import navbarSearchAndPinList from "@/layouts/components/navbar/navbarSearchAndPinList";
export default {
    //System
    navbarSearchAndPinList : {},
    starredPages : navbarSearchAndPinList["pages"].data.filter((page) => page.is_bookmarked),
    navMenuItems: navMenuItems?navMenuItems:[],
    loadingPercentProgress: 0,
    MMIO_DEFAULTS: window.MMIO_DEFAULTS,
}